<template>
	<div>
		  <Breadcrumbs main="Staffs" title="Add Staff" />
			 <div class="container-fluid">
				<div class="row">
				   <div class="col-sm-12">
					  <div class="card">
						 <div class="card-body">
 
							<div class="row mb-3">
							   	<div class="col-12">
									<a href="#" @click.prevent="$router.go(-1)" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</a>
							   	</div>
							</div>
 
							<form  @submit.prevent="addStaff" enctype="multipart/form-data">
								<div class="form theme-form">
									<div class="row">
										<div class="col-md-4">
											<div class="mb-3">
												<label class="control-label">Staff Name<span class="text-danger">*</span></label>
												<input class="form-control" type="text" placeholder="" v-model="name" v-bind:class="{ 'is-invalid': Boolean(errors.name) }"/>
												<div v-for="(val, index) in errors.name" :key="index" class="invalid-feedback">
													<p class="mb-0">{{ val }}</p>
												</div>
											</div>
										</div>

										<!--<div class="col-md-4">
											<div class="mb-3">
												<label class="control-label">Type<span class="text-danger">*</span></label>
												<select class="form-select" v-model="type" >
													<option value="">Choose Staff Type</option>
													<option value="1">Manufacturing</option>
													<option value="2">Operational & Accounts</option>
												</select>
											</div>
										</div>-->

                                        <div class="col-md-4 form-group">
                                            <label class="control-label">Mobile No.<span class="text-danger">*</span></label>
                                            <input class="form-control" placeholder="" v-model="mobile" v-mobile-limit v-bind:class="{ 'is-invalid': Boolean(errors.mobile) }" maxlength="10" minlength="10" />
											<div v-for="(val, index) in errors.mobile" :key="index" class="invalid-feedback">
												<p class="mb-0">{{ val }}</p>
											</div>
                                        </div>
									
										<div class="col-md-4">
											<div class="mb-3">
												<label class="control-label">Email<span class="text-danger">*</span></label>
												<input class="form-control" type="text" placeholder="" v-model="email" v-bind:class="{ 'is-invalid': Boolean(errors.email) }"/>
												<div v-for="(val, index) in errors.email" :key="index" class="invalid-feedback">
													<p class="mb-0">{{ val }}</p>
												</div>
											</div>
										</div>

										<div class="col-md-4">
											<div class="mb-3">
												 <label class="control-label">Password<span class="text-danger">*</span></label>
                                                <input class="form-control" type="password" placeholder="" v-model="password" v-bind:class="{ 'is-invalid': Boolean(errors.password) }"/>
												<div v-for="(val, index) in errors.password" :key="index" class="invalid-feedback">
													<p class="mb-0">{{ val }}</p>
												</div>
											</div>
										</div>

                                        <div class="col-md-4">
											<div class="mb-3">
												 <label class="control-label">Confirm Password<span class="text-danger">*</span></label>
                                                <input class="form-control" type="text" placeholder="" v-model="password_confirmation" v-bind:class="{ 'is-invalid': Boolean(errors.password_confirmation) }"/>
												<div v-for="(val, index) in errors.password_confirmation" :key="index" class="invalid-feedback">
													<p class="mb-0">{{ val }}</p>
												</div>
											</div>
										</div>

									</div>

									<div class="row mt-3">
										<div class="col-sm-12">
											<button class="btn btn-success me-2 float-end" type="submit" :disabled="submitting">
												<span v-if="submitting" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
												{{ submitting ? "Saving..." : "Save" }}
											</button>
										</div>
									</div>
	
								</div>
							</form>
						 </div>
					  </div>
				   </div>
				</div>
			 </div>
 
	</div>
 </template>

<script>
	export default {
		name: "Add Campaign Page",
		

		data() {
			return {
				
				keyword: "",
				showsearch: false,
				listing_length: 10,
				token: "",
				submitting: false,
				errors: {},

				button_title: "Save",

				email: "",
				mobile: "",
				country_code_id: "",
				name: "",
				type: "",
				gst: 1,
				password:"",
				password_confirmation:"",

				// delete: false,
				// active_page_url: null,

			};
		},
		created() {
			// this.addRow();

		},
		
		methods: {

			getToken() {
				if (localStorage.getItem('airotrack_staff')) {
					var airotrack_staff =  JSON.parse(localStorage.getItem('airotrack_staff')); 
							
					if(airotrack_staff.token) {

						this.token = airotrack_staff.token;
						this.user = airotrack_staff;

					} else {
						this.$swal("", "Failed to fetch token, please login again", "error");
						this.$router.push({ name: "login" });
					}

				} else {
					this.$swal("", "Session expired, please login again", "error");
					this.$router.push({ name: "login" });
				}
			},

			addStaff() {
				if (this.submitting) return;
				this.submitting = true;

                this.getToken();
                this.errors = {};

                const config = {
                    headers: {
                        "Content-type": "multipart/form-data",
                        "Accept": "application/json",
                        "Authorization": "Bearer " + this.token,
                    },
                };

                let url = "staffs/addStaff";

                let formData = new FormData();
                formData.append("name", this.name);
                formData.append("mobile", this.mobile);
                formData.append("email", this.email);
                formData.append("password", this.password);
                formData.append("password_confirmation", this.password_confirmation);

                    this.$axios
                    .post(url, formData, config)
                    .then((response) => {
                        if (response.data.status) {
                            this.$swal("", response.data.message, "success");
                        } else {
                            this.$swal("", response.data.message, "error");
                        }
                        this.clearForm();
                        this.$router.push({ name: 'staffs' })
                    })
                    .catch((error) => {
                        console.log(error);
                        console.log(error.response);
                        if (error.response) {
                            if (error.response.data.message) {
                                this.errors = error.response.data.message;
                                this.$swal("", error.response.data.message, "error");
                            } else {
                                this.$swal("", "Something went wrong", "error");
                            }
                        } else {
                            this.$swal("", "Something went wrong", "error");
                        }
                    })
					.finally(() => {
						this.submitting = false;
					});
            },

			clearForm() {
              
                this.errors = {};
                this.name = "";
                this.email = "";
                this.mobile = "";
                this.password = "";                
                this.password_confirmation = "";
            },
			
		},
	};

</script>